/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BusinessChallengesRequest,
  HTTPValidationError,
  OrgProfileResponse,
  OrgProfileUpdateRequest,
  OrganizationInviteRequest,
} from './platformapi.schemas';

import createBusinessChallengesMutator from '../custom-axios-instance';
import organizationInviteMutator from '../custom-axios-instance';
import getOrganizationProfileMutator from '../custom-axios-instance';
import updateOrganizationProfileMutator from '../custom-axios-instance';

/**
 * API to create or update business challenges for an organization.
 * @summary Create Business Challenges
 */
export const createBusinessChallenges = (
  businessChallengesRequest: BusinessChallengesRequest,
  signal?: AbortSignal,
) => {
  return createBusinessChallengesMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/organizations/business_challenges`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: businessChallengesRequest,
    signal,
  });
};

export const getCreateBusinessChallengesMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBusinessChallenges>>,
    TError,
    { data: BusinessChallengesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBusinessChallenges>>,
  TError,
  { data: BusinessChallengesRequest },
  TContext
> => {
  const mutationKey = ['createBusinessChallenges'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBusinessChallenges>>,
    { data: BusinessChallengesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createBusinessChallenges(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBusinessChallengesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBusinessChallenges>>
>;
export type CreateBusinessChallengesMutationBody = BusinessChallengesRequest;
export type CreateBusinessChallengesMutationError = void | HTTPValidationError;

/**
 * @summary Create Business Challenges
 */
export const useCreateBusinessChallenges = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBusinessChallenges>>,
      TError,
      { data: BusinessChallengesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBusinessChallenges>>,
  TError,
  { data: BusinessChallengesRequest },
  TContext
> => {
  const mutationOptions = getCreateBusinessChallengesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Endpoint to create new OrganizationInvites records
 * @summary Organization Invite
 */
export const organizationInvite = (
  organizationInviteRequest: OrganizationInviteRequest,
  signal?: AbortSignal,
) => {
  return organizationInviteMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/organizations/organization-invite`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: organizationInviteRequest,
    signal,
  });
};

export const getOrganizationInviteMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationInvite>>,
    TError,
    { data: OrganizationInviteRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationInvite>>,
  TError,
  { data: OrganizationInviteRequest },
  TContext
> => {
  const mutationKey = ['organizationInvite'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationInvite>>,
    { data: OrganizationInviteRequest }
  > = (props) => {
    const { data } = props ?? {};

    return organizationInvite(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationInvite>>
>;
export type OrganizationInviteMutationBody = OrganizationInviteRequest;
export type OrganizationInviteMutationError = void | HTTPValidationError;

/**
 * @summary Organization Invite
 */
export const useOrganizationInvite = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationInvite>>,
      TError,
      { data: OrganizationInviteRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof organizationInvite>>,
  TError,
  { data: OrganizationInviteRequest },
  TContext
> => {
  const mutationOptions = getOrganizationInviteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Endpoint to get organization profile by organization_id
 * @summary Get Organization Profile
 */
export const getOrganizationProfile = (signal?: AbortSignal) => {
  return getOrganizationProfileMutator<OrgProfileResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/organizations/profile`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationProfileQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/organizations/profile`] as const;
};

export const getGetOrganizationProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationProfile>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProfile>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationProfile>>> = ({ signal }) =>
    getOrganizationProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOrganizationProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationProfile>>
>;
export type GetOrganizationProfileQueryError = void | HTTPValidationError;

export function useGetOrganizationProfile<
  TData = Awaited<ReturnType<typeof getOrganizationProfile>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProfile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationProfile>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationProfile<
  TData = Awaited<ReturnType<typeof getOrganizationProfile>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProfile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationProfile>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationProfile<
  TData = Awaited<ReturnType<typeof getOrganizationProfile>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProfile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organization Profile
 */

export function useGetOrganizationProfile<
  TData = Awaited<ReturnType<typeof getOrganizationProfile>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationProfile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOrganizationProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Endpoint to update organization profile by organization_id
 * @summary Update Organization Profile
 */
export const updateOrganizationProfile = (
  orgProfileUpdateRequest: OrgProfileUpdateRequest,
  signal?: AbortSignal,
) => {
  return updateOrganizationProfileMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/organizations/profile`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: orgProfileUpdateRequest,
    signal,
  });
};

export const getUpdateOrganizationProfileMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationProfile>>,
    TError,
    { data: OrgProfileUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganizationProfile>>,
  TError,
  { data: OrgProfileUpdateRequest },
  TContext
> => {
  const mutationKey = ['updateOrganizationProfile'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganizationProfile>>,
    { data: OrgProfileUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateOrganizationProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganizationProfile>>
>;
export type UpdateOrganizationProfileMutationBody = OrgProfileUpdateRequest;
export type UpdateOrganizationProfileMutationError = void | HTTPValidationError;

/**
 * @summary Update Organization Profile
 */
export const useUpdateOrganizationProfile = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganizationProfile>>,
      TError,
      { data: OrgProfileUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganizationProfile>>,
  TError,
  { data: OrgProfileUpdateRequest },
  TContext
> => {
  const mutationOptions = getUpdateOrganizationProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
